import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import { kioskCartFunnelTopPaddingProperty } from './kiosk-cart-funnel-top-padding';

export const KIOSKCARTFUNNELPAGERBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "subtitle",
  "required",
  "color",
  "pager_size",
  "top_padding"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelPagerBlockDescriptor: _generatedKioskCartFunnelPagerBlockDescriptor,
  kioskCartFunnelPagerBlockBlocDefinition,
  kioskCartFunnelPagerBlockDashboardLayout,
  kioskCartFunnelPagerBlockConfig,
  kioskCartFunnelPagerBlockResolveConfig,
  kioskCartFunnelPagerBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / Pager (Digit pad)",
    componentType: 'KioskCartFunnelPagerBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / Pager (Digit pad).",
    keywords: [],
    allowedIn: [
      { bloc: "KioskCartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-pager.title.label",
      }
    }),
    subtitle: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-pager.subtitle.label",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-pager.required.label",
      }
    }),
    color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-pager.color.label",
      }
    }),
    pager_size: propertyValue({
      type: 'number',
      value: 2,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-pager.pager-size.label",
        help: "pages.blocks.kiosk-cart-funnel-pager.pager-size.help",
        placeholder: "2"
      }
    }),
    top_padding: kioskCartFunnelTopPaddingProperty('kiosk-cart-funnel-pager'),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-pager.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-pager.fieldset.field.label",
            fields: [
              "title",
              "subtitle",
              "required",
              "pager_size",
              "color",
              "top_padding",
            ],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelPagerBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelPagerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelPagerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelPagerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelPagerBlockDescriptor, kioskCartFunnelPagerBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelPagerBlockBlocDefinition,
  kioskCartFunnelPagerBlockDashboardLayout,
  kioskCartFunnelPagerBlockProperties,
  kioskCartFunnelPagerBlockConfig,
  kioskCartFunnelPagerBlockResolveConfig,
};

export type KioskCartFunnelPagerBlockConfig = typeof kioskCartFunnelPagerBlockConfig;
